import { Component, Input } from '@angular/core';
import { APP_CONFIG, Region } from '../../environment';
import { SendFlowProvider } from '../../providers/send-flow/send-flow';
import { NumberFormatter } from '../../pipes/currency-pipe';
import { PriceCalculatorProvider } from '../../providers/price-calculator/price-calculator';
import { SegmentProvider } from '../../providers/analytics/segment';
import { AnalyticsEventType, UserLoggingStatus } from '../../model/types/analytics.const';
import { UtilsProvider } from '../../providers/myria/utils-provider';

/**
 * Generated class for the RmtRateWidgetComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'rmt-rate-widget',
  templateUrl: 'rmt-rate-widget.html'
})
export class RmtRateWidgetComponent {
  @Input() countryTo;
  @Input() sendCurrency;
  @Input() recieveCurrency;
  @Input() amountFrom;
  @Input() rate;
  @Input() ratePromo;
  countryFrom = APP_CONFIG.region.defaultCountryFrom;

  constructor(
    private sendFlowProvider: SendFlowProvider,
    private currencyFormatter: NumberFormatter,
    private analytics: SegmentProvider,
    private utilsProvider: UtilsProvider,
    
     
  ){ }

  getFlagUrl(country): string {
    return 'assets/countryFlagSvg/' + country + '.svg';    
  }

  getPromoHint(promo = false) {
    let rate = this.rate;
    if (promo)
     rate = this.ratePromo;

    if (rate) {
      const convertedRate = PriceCalculatorProvider.updateRate(rate)
      return this.currencyFormatter.transform(convertedRate, null);
    }
    return ''
  }

  selectCountry() {
   this.sendFlowProvider.showCountryPicker(false, null, true);
  }

  continue() {
    this.sendFlowProvider.sendMoneyBtn(true, true , this.countryTo);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-rate-widget/rmt-rate-widget.ts